export var DEPLOY_DATE = new Date('2026-04-27T11:22:48+0000');
